import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ITAFBookB5 } from './taf-book-b5-list';


import { HttpHelper } from '../../../shared/http-helper';

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class TAFBookB5Service {

    //need to have this somewhere besides hardcoded in here

    //private _tafBookB5Url = ` http://localhost:55706/api/systemmanagement/TAFBookB5`;
    private _tafBookB5Url = `api/systemmanagement/TAFBookB5`;


    constructor(private httpHelper: HttpHelper) { }

    getTAFBookB5(): Observable<ITAFBookB5> {
         return this.httpHelper.get(`${this._tafBookB5Url}`)
             //.map((response: Response) => <ITAFBookB5> response.json())
             //.do(httpHelper => console.log('ITafBookB5: ' +  JSON.stringify(data)))
             //.catch(this.handleError);
    }

   
    private handleError(error: Response) {
         // in a real world app, we may send the server to some remote logging infrastructure
         // instead of just logging it to the console
                 
         console.error(error);
         return Observable.throw(error.json().error || 'Server error');
    }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/tafbooks/taf-book-b5/taf-book-b5.service.ts
 **/